import { InjectionToken } from '@angular/core';

export interface IControlServiceCheck {
    controlWithSingleDataBindingExists: (binding: string) => boolean;
}

export const controlServiceCheckToken = new InjectionToken<IControlServiceCheck>('ControlServiceCheck');
